
export default class ParallexElement {
    protected element: HTMLElement;
    protected _target: HTMLElement;
    protected _rect: DOMRect;
    protected _sentinel: HTMLElement;
    protected _yPosition: number;
    protected _height: number;
    protected _isTop: boolean;
    protected observer: IntersectionObserver;
    protected _reduceScrollingEffectBy: number;


    constructor(element) {
        this.element = element;
        this._isTop = element.classList.contains('parallax--top');
        this._reduceScrollingEffectBy = this.element.dataset?.reduceScrollingEffectBy
            ? 1 - parseInt(this.element.dataset.reduceScrollingEffectBy) * 0.01
            : 1;
    }

    set target(element: HTMLElement) {
        this._target = element;
    }

    get target(): HTMLElement {
        return this._target;
    }

    set rect(newRect: DOMRect) {
        this._rect = newRect;
    }

    get rect(): DOMRect {
        return this._rect;
    }


    get sentinel(): HTMLElement {
        return this._sentinel;
    }

    get height(): number {
        return this._height
    }

    get yPosition(): number {
        return this._yPosition;
    }

    set yPosition(newPosition: number) {
        this._yPosition = newPosition;
    }

    get isTop(): boolean {
        return this._isTop;
    }

    get reduceScrollingEffectBy(): number {
        return this._reduceScrollingEffectBy;
    }

    public updateRect() {
        this.rect = this.element.getBoundingClientRect();
        this.updateHeight(this.rect.height);
        this._yPosition = -1;
    }

    public updateHeight(height: number = null) {
        this._height = height ? height : this.element.getBoundingClientRect().height;
    }

    public configureSentinel() {
        const bodyRect = document.body.getBoundingClientRect();
        const { element, sentinel } = this;
        this.rect = element.getBoundingClientRect();
        const sentinelTop = ((this.rect.top - bodyRect.top) + (this.rect.height / 2)) - (window.innerHeight / 2);
        if (this.rect.height >= window.innerHeight) {
            requestAnimationFrame(() => {
                sentinel.style.height = `${window.innerHeight}px`;
                sentinel.style.bottom = 'unset';
                sentinel.style.top = `${(this.rect.top - bodyRect.top)}px`;
            });
        } else if (bodyRect.height > sentinelTop + window.innerHeight) {
            requestAnimationFrame(() => {
                this.sentinel.style.height = `${window.innerHeight}px`;
                this.sentinel.style.bottom = 'unset';
                this.sentinel.style.top = `${sentinelTop}px`;
            });
        } else {
            requestAnimationFrame(() => {
                this.sentinel.style.height = 'unset';
                this.sentinel.style.bottom = '0';
                this.sentinel.style.top = `${sentinelTop}px`;
            });
        }
    }


    createSentinel(sentinelCount) {
        const sentinel = document.createElement('div');
        sentinel.className = 'parallax__sentinel';
        sentinel.style.left = `${sentinelCount}px`;
        this._sentinel = sentinel;
        this.configureSentinel();
        document.body.appendChild(this.sentinel);
        return sentinelCount + 1;
    }

}

